/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type UserPopoverContainer_user = {
    readonly id: string;
    readonly " $fragmentRefs": FragmentRefs<"UserPopoverOverviewContainer_user" | "UserIgnorePopoverContainer_user">;
    readonly " $refType": "UserPopoverContainer_user";
};
export type UserPopoverContainer_user$data = UserPopoverContainer_user;
export type UserPopoverContainer_user$key = {
    readonly " $data"?: UserPopoverContainer_user$data;
    readonly " $fragmentRefs": FragmentRefs<"UserPopoverContainer_user">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "UserPopoverContainer_user",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "UserPopoverOverviewContainer_user"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "UserIgnorePopoverContainer_user"
        }
    ],
    "type": "User",
    "abstractKey": null
} as any);
(node as any).hash = '444f60a1501d6042c017f340236d10b8';
export default node;
